import { formatTimelineClock } from '../actionVisuals';
import type { TimelineEvent } from '../types';

interface ActionDetailTimelineProps {
  events: TimelineEvent[];
}

function renderEventText(event: string) {
  const parts = event.split(/(`[^`]+`)/g);
  return parts.map((part, i) => {
    if (part.startsWith('`') && part.endsWith('`')) {
      const code = part.slice(1, -1);
      return (
        <code
          key={i}
          className="text-xs bg-gray-50 dark:bg-gray-800 px-1.5 py-0.5 rounded font-mono"
        >
          {code}
        </code>
      );
    }
    return <span key={i}>{part}</span>;
  });
}

export default function ActionDetailTimeline({ events }: ActionDetailTimelineProps) {
  if (!events.length) {
    return <div className="text-sm text-gray-500">No timeline events.</div>;
  }

  return (
    <div className="flex flex-col">
      {events.map((ev, i) => {
        const isLast = i === events.length - 1;
        const levelClass = ev.level === 'error'
          ? 'text-red-600 dark:text-red-400'
          : ev.level === 'warning'
            ? 'text-amber-600 dark:text-amber-400'
            : 'text-gray-900 dark:text-gray-100';

        return (
          <div
            key={`${ev.time}-${i}`}
            className={`flex gap-3 py-2.5 ${isLast ? '' : 'border-b border-gray-200/80 dark:border-gray-700'}`}
          >
            <p className="text-xs text-gray-400 dark:text-gray-500 m-0 w-[60px] flex-shrink-0 font-mono">
              {formatTimelineClock(ev.time)}
            </p>
            <p className={`text-sm m-0 flex-1 ${levelClass}`}>
              {renderEventText(ev.event)}
            </p>
          </div>
        );
      })}
    </div>
  );
}
